module.exports = __webpack_public_path__ + "static/media/add section.fb29797f.svg";